import { render, staticRenderFns } from "./DMIDHome.vue?vue&type=template&id=4d1ea33e&scoped=true&"
import script from "./DMIDHome.vue?vue&type=script&lang=js&"
export * from "./DMIDHome.vue?vue&type=script&lang=js&"
import style0 from "./DMIDHome.vue?vue&type=style&index=0&id=4d1ea33e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1ea33e",
  null
  
)

export default component.exports